import React from "react"

import "./index.css"

export default function Heading() {
  return (
    <div className="main-heading-one">
      <h3>Your Favorite Countries</h3>
    </div>
  )
}
